import { connect } from "react-redux";
import Corporate from "./corporate";
import { bindActionCreators } from "redux";
import { LeadSource } from "services/redux/sales/corporate/leadDetails/action";
import { pocType } from "services/redux/sales/corporate/pocDetails/action";
import {
  leadCategories,
  rwaTenureFun,
  supplyNameFun,
  getCorporateDropDown,
} from "services/redux/sales/corporate/categoryDetails/action";

import {
  locationArea,
  locationCity,
  locationPinCode,
  locationState,
  locationType,
  locationZone,
} from "services/redux/sales/corporate/locations/action";
import { createCorporateLead } from "services/redux/sales/corporate/action";
import { getCurrentLocation } from "services/redux/sales/currentLocation/action";
import { excelUploadUrl } from "services/redux/fileUpload/action";
import { BulkUploadLead ,getSampleFileLead} from "services/redux/sales/importLead/action";
import { showHideToast } from "services/redux/sales/appNotifications/action";

const mapStateToProps = (state) => ({
  sourceData: state.LeadDetailsReducer.LeadSources,
  pocTypeData: state.pocTypesReducer.pocTypeData,
  leadCategory: state.categoryDetlReducer.leadCategory,
  rwaTenureData: state.categoryDetlReducer.rwaTenureData,
  splNameData: state.categoryDetlReducer.splNameData,
  cities: state.locationReducer.cities,
  zones: state.locationReducer.zones,
  areas: state.locationReducer.areas,
  state: state.locationReducer.state,
  pincodeData: state.locationReducer.pincodeData,
  locTypesData: state.locationReducer.locTypesData,
  corDropDownData: state.categoryDetlReducer.corDropDownData,
  latlng: state.currentLocationReducer.latlng,
  toastMsg: state.toastReducer,
  sampleData: state.importReducer.sampleData,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      LeadSource,
      pocType,
      leadCategories,
      locationCity,
      locationZone,
      locationArea,
      locationType,
      locationState,
      createCorporateLead,
      locationPinCode,
      supplyNameFun,
      rwaTenureFun,
      getCorporateDropDown,
      getCurrentLocation,
      excelUploadUrl,
      BulkUploadLead,
      showHideToast,
      getSampleFileLead,
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(Corporate);
